import axios from "axios";
import { AccountRootCreate, AccountRootResponse, AccountRootUpdate } from "../../types/models";


const REACT_APP_API_URL = process.env.REACT_APP_API_URL || "http://127.0.0.1:8000";
const BASE_URL = `${REACT_APP_API_URL}`;

const getAuthHeaders = (): Record<string, string> => {
  const token = localStorage.getItem("authToken");
  if (!token) throw new Error("Unauthorized: No token found.");
  return {
    "Content-Type": "application/json",
    Authorization: `Bearer ${token}`,
  };
};

export const createAccountRoot = async (
  data: AccountRootCreate
): Promise<AccountRootResponse> => {
  try {
    const response = await axios.post(`${BASE_URL}/account-root/`, data, {
      headers: getAuthHeaders(),
    });
    return response.data;
  } catch (error) {
    handleAxiosError(error, "create Account Root");
    throw error;
  }
};

export const getAccountRootById = async (
    rootId: number
  ): Promise<AccountRootResponse> => {
    try {
      const response = await axios.get(`${BASE_URL}/account-root/${rootId}`, {
        headers: getAuthHeaders(),
      });
      return response.data;
    } catch (error) {
      handleAxiosError(error, "get Account Root by ID");
      throw error;
    }
  };
  
  

  export const getAllAccountRoots = async (
    skip: number = 0,
    limit: number = 100
  ): Promise<AccountRootResponse[]> => {
    try {
      const response = await axios.get(`${BASE_URL}/account-root/`, {
        headers: getAuthHeaders(),
        params: { skip, limit },
      });
      return response.data;
    } catch (error) {
      handleAxiosError(error, "get all Account Roots");
      throw error;
    }
  };
  
  export const updateAccountRoot = async (
    rootId: number,
    data: AccountRootUpdate
  ): Promise<AccountRootResponse> => {
    try {
      const response = await axios.put(`${BASE_URL}/account-root/${rootId}`, data, {
        headers: getAuthHeaders(),
      });
      return response.data;
    } catch (error) {
      handleAxiosError(error, "update Account Root");
      throw error;
    }
  };
  
  export const deleteAccountRoot = async (
    rootId: number
  ): Promise<boolean> => {
    try {
      const response = await axios.delete(`${BASE_URL}/account-root/${rootId}`, {
        headers: getAuthHeaders(),
      });
      return response.status === 200;
    } catch (error) {
      handleAxiosError(error, "delete Account Root");
      throw error;
    }
  };
  

const handleAxiosError = (error: unknown, action: string): never => {
  if (axios.isAxiosError(error)) {
    console.error(`Error during ${action}:`, error.response?.data || error.message);
    throw new Error(error.response?.data?.detail || error.message);
  } else {
    console.error(`Unexpected error during ${action}:`, (error as Error).message);
    throw error;
  }
};
